export const DATA_COLUMN_WIDTH = 96;
